<template>
  <div class="control-input">
    <textarea type="number" :readonly="readonly" :value="value" @input="change($event)" @dblclick.stop=""></textarea>
  </div>
</template>

<script>
  import plotDetailPopUpGraph from '../../util/density/plotDetailPopUpGraph';
  import Vue from 'vue';
  import * as d3 from 'd3';
  import CalculatePreviewDensity from '../../util/density/CalculatePreviewDensity';
  import CalculatePreviewHighlightDensity from '../../util/density/CalculatePreviewHighlightDensity';

  export default {
    name: 'VuewResultControl',
    props: ['readonly', 'emitter', 'ikey', 'getData', 'putData'],
    data() {
      return {
        value: '',
      }
    },
    methods: {
      change(e){
        this.value = +e.target.value;
        this.update();
      },
      update() {
        if (this.ikey)
          this.putData(this.ikey, this.value)
        this.emitter.trigger('process');
      }
    },
    mounted() {
      this.value = this.getData(this.ikey);
      // console.log(this.value, this.getData, this.ikey, this.getData(this.ikey));
    },
    watch: {
      value: function (val, oldVal) {
        this.value = val || '';
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
